import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { router } from "./router";
import "./index.css";

const rootElement = document.getElementById("root")!;

const app = (
  <StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Prerendered HTML exists — hydrate on top of it
  hydrateRoot(rootElement, app);
} else {
  // SPA fallback (dev mode, non-prerendered routes)
  createRoot(rootElement).render(app);
}
